import React, { useState } from "react";
import { Button, Spinner } from "reactstrap";
import { useFormContext } from "react-hook-form";
import ReactCountryFlag from "react-country-flag";

import DropDownSelectFromList from "../../../CommonElements/DropDownSelectFromList";
import { getDropdownOptions, getCamelCaseWord } from "../../../static/brands_wholesalers_data";
import { toast } from "react-toastify";

const EditBrandFormFieldLocationColumn = ({ column }) => {
  const [openDropDown, setOpenDropDown] = useState(false);
  const { setValue, watch } = useFormContext();
  const data = watch(column.field);

  const _handleAdd = (value) => {
    if (
      column.title === "Location"
    ) {
      return setValue(column.field, [value]);
    }

    if (data?.find((d) => d.id === value.id)) {
      toast.info("Already added");
      setOpenDropDown(false);
      return;
    }

    setValue(column.field, [...(data ? data : []), value]);
    setOpenDropDown(false);
  };


  const _handleDelete = (id) => {
    setValue(
      column.field,
      data.filter((d) => d.id !== id)
    );
    setOpenDropDown(false);
  };

  return (
    <div className="flex-column align-items-center text-center p-2" style={{ flex: 1, minWidth: 150 }}>
      <h5 className="text-center mt-2" style={{ fontSize: "18px", height: '50px', fontWeight: 500 }}>
        {column.title}
      </h5>

      {data?.length > 0 ? (
        data.map((item, i) => (
          <div
            key={i}
            className="d-flex flex-column align-items-center justify-content-center position-relative my-2"
            style={{
              height: "110px",
              width: "120px",
              backgroundColor: "#000",
              borderRadius: "12px",
              padding: "5px",
              margin: "0 auto",
            }}
          >
            {item?.label === "Open" ? (
              <span style={{ color: "white", fontSize: "30px" }}>🌐</span>
            ) : item?.code ? (
              <ReactCountryFlag
                countryCode={item?.code}
                svg
                style={{
                  width: "30px",
                  height: "30px",
                }}
              />
            ) : <span style={{ color: "white", fontSize: "30px" }}>🌐</span>}
            <h6
              className="text-white text-center mt-2"
              style={{ fontSize: "14px", fontWeight: 600 }}
            >
              {getCamelCaseWord(item?.label || item)}
            </h6>
            <Button
              size="sm"
              color="warning"
              className="position-absolute"
              style={{
                top: "-10px",
                right: "-5px",
                padding: "2px 6px",
                fontSize: "12px",
                borderRadius: "50%",
              }}
              onClick={() => _handleDelete(item.id)}
            >
              ×
            </Button>
          </div>
        ))
      ) : (
        <div className="d-flex justify-content-center align-items-center mt-4 gap-2">
          <Spinner size="sm" color="primary" />
          <span style={{ fontSize: "14px", color: "#0D99FF" }}>Fetching</span>
        </div>
      )}

      {openDropDown ? (
        <DropDownSelectFromList
          data={getDropdownOptions(column.field)}
          isNested
          values={data}
          onValueSelect={_handleAdd}
        />
      ) : (
        <div className="mt-2">
          <Button
            size="sm"
            style={{
              backgroundColor: "#DCDCDC",
              borderRadius: "50%",
              border: "none",
            }}
            onClick={() => setOpenDropDown(true)}
          >
            +
          </Button>
        </div>
      )}
    </div>
  );
};

export default EditBrandFormFieldLocationColumn;
